module.exports = __webpack_public_path__ + "img/calendar.f237ed0c.svg";